import moment from 'moment';

function getFinancialYear(identifier) {

    let month = moment().format("M");
    let year = moment().format("Y");
    if (month < 7) {
        if (identifier === 'Start') {
            let startDate = "01 Jul " + (year - 1);
            return moment(startDate).format('D MMM YYYY');
        }
        else {
            let endDate = "30 Jun " + (year);
            return moment(endDate).format('D MMM YYYY')
        }
    }

    if (month < 13) {
        if (identifier === 'Start') {
            let startDate = "01 Jul " + (year);
            return moment(startDate).format('D MMM YYYY')
        }
        else {
            let endDate = "30 Jun " + (year + 1);
            return moment(endDate).format('D MMM YYYY')
        }
    }
}

function buildProperty(data, properties) {
	let propertyValue = "";
	let propertiesConcat = "";

	if ( properties.length > 0 ) {
		let property1 = "";

		properties.forEach(function (property) {
			propertyValue = data[property.value.toString()];

			if ( propertyValue == undefined ) propertyValue = property.value;

			property1 = property.property + '="' + propertyValue + '" ';
			propertiesConcat += property1;
		});

	}

	return propertiesConcat;
}

function buildContent(content) {
	return content != null ? content : '';
}

export const commonFunctions =
    {
      getFinancialYear,
	    buildProperty,
	    buildContent
    };



// WEBPACK FOOTER //
// ./src/common/commonFunctions.js